import Deck from "./Deck";
import './App.css';

const App = () => (
    <main className="App">
        <Deck />
    </main>
);

export default App;
